import { ResourceState } from '../types/evalform';

/**
 * Form Utilities
 * Common functions for handling form states and operations across different form types
 */

/**
 * Check if a form is active based on its state
 * @param state_id - The current state of the form
 * @returns true if the form is active, false otherwise
 */
export const is_active = (state_id: ResourceState): boolean => {
  return state_id === ResourceState.NEW || 
         state_id === ResourceState.IN_PROGRESS || 
         state_id === ResourceState.COMPLETED;
};

/**
 * Check if a form is editable based on its state
 * @param state_id - The current state of the form
 * @returns true if the form can be edited, false otherwise
 */
export const is_editable = (state_id: ResourceState): boolean => {
    // console.trace()
    // console.log("is_editable state_id = ", state_id)
  return state_id === ResourceState.NEW || 
         state_id === ResourceState.IN_PROGRESS;
};

/**
 * Determine the next state based on the action being performed and current state
 * @param action - The action being performed ('save' | 'submit' | 'activate' | 'deactivate')
 * @param current_state_id - The current state of the form
 * @returns The new ResourceState that should be set
 */
export const change_state = (action: string, current_state_id: ResourceState): ResourceState => {
  const normalizedAction = action.toLowerCase();
  switch (normalizedAction) {
    case 'save':
      return ResourceState.IN_PROGRESS;
    
    case 'submit':
      return ResourceState.COMPLETED;
    
    case 'activate':
      if (current_state_id === ResourceState.INACTIVE_IN_PROGRESS) {
        return ResourceState.IN_PROGRESS;
      } else if (current_state_id === ResourceState.INACTIVE_COMPLETED) {
        return ResourceState.COMPLETED;
      }
      return current_state_id; // No change if not in inactive state
    
    case 'deactivate':
      if (current_state_id === ResourceState.IN_PROGRESS) {
        return ResourceState.INACTIVE_IN_PROGRESS;
      } else if (current_state_id === ResourceState.COMPLETED) {
        return ResourceState.INACTIVE_COMPLETED;
      }
      return current_state_id; // No change if already inactive
    
    default:
      return current_state_id; // Return current state for unknown actions
  }
};

/**
 * Get the display name for a ResourceState
 * @param state_id - The ResourceState enum value
 * @returns A human-readable string representation of the state
 */
export const get_state_display_name = (state_id: ResourceState): string => {
  // TODO: Implement mapping of ResourceState to display names
  return 'Unknown';
};

/**
 * Check if a form can be submitted based on its current state
 * @param state_id - The current state of the form
 * @returns true if the form can be submitted, false otherwise
 */
export const can_submit = (state_id: ResourceState): boolean => {
  return state_id === ResourceState.NEW || 
         state_id === ResourceState.IN_PROGRESS;
};

/**
 * Check if a form can be saved based on its current state
 * @param state_id - The current state of the form
 * @returns true if the form can be saved, false otherwise
 */
export const can_save = (state_id: ResourceState): boolean => {
  return state_id === ResourceState.NEW || 
         state_id === ResourceState.IN_PROGRESS;
}; 